import React from 'react';

import CountryInfo from '../CountryInfo';

const STIMULUS_SECTION = {
    title: 'Stimulus Package',
    content: (
        <div>
            <p className="eds-text-bl eds-l-mar-bot-4">Details</p>
            <ul>
                <li>
                    Productive Recovery Program (REPRO) to be expanded to
                    guarantee the employment of those working in the companies
                    affected
                </li>
                <li>Reinforcement of Unemployment Insurance</li>
                <li>
                    $350,000 M for production and supply of food and basic
                    supplies, boost activity and finance the operation of the
                    economy
                </li>
                <li>
                    To be implemented by the Central Bank, through a regulatory
                    rule of the banking system, a mandatory credit line for $
                    320,000 M allowing a working capital to companies at
                    preferential rates for a period of 180 days.
                </li>
                <li>
                    Maximum amount of the financing will be the equivalent to
                    the payroll of said companies registered in the last F.931.
                    The interest rate will be 26% per year.
                </li>
            </ul>
        </div>
    ),
    links: [
        {
            title: 'Los ministros de Economía y de Desarrollo Productivo anunciaron un paquete de medidas para paliar el impacto económico de la pandemia del COVID-19',
            url: 'https://www.argentina.gob.ar/noticias/los-ministros-de-economia-y-de-desarrollo-productivo-anunciaron-un-paquete-de-medidas-para',
        },
    ],
};

const COUNTRY_INFO = {
    countryName: 'Argentina',
    lastUpdated: 'March 21, 2020',
    introSection: (
        <p>
            Argentina has announced a variety of measures to assist with
            financial relief.
        </p>
    ),
    sections: [STIMULUS_SECTION],
};

const ArgentinaInfo = () => <CountryInfo info={COUNTRY_INFO} />;

export default ArgentinaInfo;
